const margin = 10;
const topbarHeight = 55; //48
const subHeaderbarHeight = 70;
const appDrawerWidth = 230;
const appDrawerItemHeight = 45;
const appDrawerItemWidth = 175;
const pageDrawerWidth = 220;
const pageDrawerWidthSmall = 150;
const minimumPageWidth = 800;

export const dimensions = {
  topbarHeight: topbarHeight,
  subHeaderbarHeight: subHeaderbarHeight,
  totalTopbarHeight: topbarHeight + margin,
  totalTopbarHeightWithSubHeaderbar: topbarHeight + subHeaderbarHeight + margin * 2,
  pageDrawerWidth: pageDrawerWidth,
  pageDrawerWidthSmall: pageDrawerWidthSmall,
  appDrawerWidth: appDrawerWidth,
  appDrawerItemHeight: appDrawerItemHeight,
  appDrawerItemWith: appDrawerItemWidth,
  totalAppDrawerWidth: appDrawerWidth + margin * 3,
  totalAppDrawerWithPageDrawer: appDrawerWidth + pageDrawerWidth + margin * 3,
  totalAppDrawerWithPageDraweSmall: appDrawerWidth + pageDrawerWidthSmall + margin * 3,
  margin: margin,
  heightAppBar: topbarHeight,
  minimumPageWidth: minimumPageWidth,
};

export const getDimensions = () => dimensions;
